import { defineWidget } from '../../client/lib/contract/helpers'
import { t } from '../../client/i18n'
import { intervalSchema } from '../../client/families/sys/data'
import { sysBoardRender } from '../../client/families/sys/renders'

/** 2×4 monitoring dashboard: every hardware metric as a ring. */
export default defineWidget({
  id: 'sys-board',
  name: () => t('widget.sys-board.name'),
  desc: () => t('widget.sys-board.desc'),
  builtin: false,
  group: 'device',
  // MUST mirror the manifest: the runtime sizesOf() reads THIS descriptor, not
  // the manifest — gen-registry now fails the build when the two disagree.
  sizes: ['2x4'],
  configSchema: intervalSchema(),
  render: sysBoardRender,
})